import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import api from "../../../services/api"
import { toast } from "react-toastify";
import HttpAPICall from "../../../services/HttpAPICall";
import { APP_BASE_URL_2 } from "../../../services/TapApiUrls";
import TapHelper from "../../../services/TapHelper";
import Footer from "../common/Footer";
import TopHeader from "../common/TopHeader";
import Ax from "../../../components/hoc/Ax";
import TapIcon from "../../../services/TapIcon";
import Asset from "./Asset";

const Auth = () => {

    const history                                    =    useHistory()
    const inputRefs                                  =    useRef([]);
    const timerRef                                   =    useRef(null);
    const query                                      =    new URLSearchParams(history.location.search);
    const assetId                                    =    query.get("asset");

    const [step, setStep]                            =    useState(1);
    const [mobileDisplay, setMobileDisplay]          =    useState("");
    const [loading, setLoading]                      =    useState(false);
    const [countdown, setCountdown]                  =    useState(60);
    const [isResendDisabled, setIsResendDisabled]    =    useState(true);
    const [otpInputs, setOtpInputs]                  =    useState(["", "", "", "", "", ""]);
    const [formData, setFormData]                    =    useState({
                                                                        passcode: "",
                                                                        mobile: "",
                                                                        otp: "",
                                                                     });

 

    const handleChange          =   (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const generateDeviceId      =   () => {
        return "DEV-" + Date.now() + "-" + Math.random().toString(36).substring(2, 12);
    };

    useEffect(() => {
        const token = TapHelper.getPasscodeToken();
        const expiry = Number(TapHelper.getPasscodeExpiry());

        if (token && expiry > 0) {
            setFormData({
                passcode: TapHelper.cookiesGet("passcode_passcode") || "",
                mobile: TapHelper.cookiesGet("passcode_mobile") || "",
                otp: "",
            });

            setMobileDisplay(
                TapHelper.cookiesGet("passcode_mobile_display") || ""
            );
            setStep(4);
        }
    }, []);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
            setFormData({
                passcode: "",
                mobile: "",
                otp: "",
            });
            setOtpInputs(["", "", "", "", "", ""]);
        };
    }, []);

    useEffect(() => {
        if (step === 2) {
            setCountdown(60);
            setIsResendDisabled(true);

            if (timerRef.current) {
                clearInterval(timerRef.current);
            }

            timerRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } else {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [step]);

    const isLoginValid = formData.passcode && formData.mobile.length === 10;
    const isOtpValid = formData.otp.length === 6;

    const handleSendOTP = () => {
        const deviceId = generateDeviceId();
        TapHelper.setPasscodeDeviceId(deviceId);
        const data = {
            action      :   "asset",
            entity_key  :   assetId,
            passcode    :   formData.passcode,
            mobile      :   formData.mobile,
        };
        setLoading(true);
        api.serverPasscodeApi
            .post(APP_BASE_URL_2 + "/passcode/auth/send-otp", data)
            .then((response) => {
                setMobileDisplay(response.data?.mobile)
                setLoading(false);
                clearOTP();
                toast.success(response.data.message || response.data.msg);
                setStep(2);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(
                    err?.response?.data?.message ||
                    "Unable to send OTP."
                );
            });
    };

    const handleResendOTP = () => {
        if (isResendDisabled) return;

        const deviceId = TapHelper.getPasscodeDeviceId() || generateDeviceId();
        TapHelper.setPasscodeDeviceId(deviceId);
        const data = {
            action      :   "asset",
            entity_key  :   assetId,
            passcode    :   formData.passcode,
            mobile      :   formData.mobile,
        };
        setLoading(true);
        api.serverPasscodeApi
            .post(APP_BASE_URL_2 + "/passcode/auth/send-otp", data)
            .then((response) => {
                setLoading(false);
                clearOTP();
                toast.success("OTP resent successfully!");
                setCountdown(60);
                setIsResendDisabled(true);
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                }
                timerRef.current = setInterval(() => {
                    setCountdown((prev) => {
                        if (prev <= 1) {
                            clearInterval(timerRef.current);
                            setIsResendDisabled(false);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(
                    err?.response?.data?.message ||
                    "Unable to resend OTP."
                );
            });
    };

    const clearOTP = () => {
        setOtpInputs(["", "", "", "", "", ""]);
        setFormData((prev) => ({
            ...prev,
            otp: "",
        }));
    };

    const handleVerifyOTP = () => {
        const deviceId = TapHelper.getPasscodeDeviceId();
        const data = {
            action: "asset",
            entity_key: assetId,
            passcode: formData.passcode,
            mobile: formData.mobile,
            otp: formData.otp,
            device_id: deviceId,
        };
        setLoading(true);
        api.serverPasscodeApi
            .post(APP_BASE_URL_2 + "/passcode/auth/verify-otp", data, {})
            .then((response) => {
                setLoading(false);
                clearOTP();
                setStep(3);
                TapHelper.setPasscodeToken(response.data.access_token);
                TapHelper.setPasscodeExpiry(response.data.expires_in);
                TapHelper.cookiesSet("passcode_passcode", formData.passcode);
                TapHelper.cookiesSet("passcode_mobile", formData.mobile);
                TapHelper.cookiesSet(
                    "passcode_mobile_display",
                    mobileDisplay || response.data.mobile || formData.mobile
                );
                setTimeout(() => {
                    setStep(4);
                }, 2000);
            })
            .catch((err) => {
                setLoading(false);
                clearOTP();
                toast.error(
                    err?.response?.data?.message || "Unable to verify OTP."
                );
            });
    };

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;

        const otp = [...otpInputs];
        otp[index] = value.slice(0, 1);
        setOtpInputs(otp);
        setFormData((prev) => ({
            ...prev,
            otp: otp.join(""),
        }));

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otpInputs[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        if (/^\d{6}$/.test(pastedData)) {
            const otp = pastedData.split('');
            setOtpInputs(otp);
            setFormData((prev) => ({
                ...prev,
                otp: otp.join(""),
            }));
            inputRefs.current[5]?.focus();
        }
    };
    const handleSessionExpired = () => {
        TapHelper.removePasscodeToken();
        TapHelper.removePasscodeExpiry();
        TapHelper.removePasscodeDeviceId();
        TapHelper.cookiesRemove("passcode_passcode");
        TapHelper.cookiesRemove("passcode_mobile");
        TapHelper.cookiesRemove("passcode_mobile_display");
        clearOTP();
        setFormData({
            passcode: "",
            mobile: "",
            otp: "",
        });
        setStep(1);
    };
    const editData = () => {
        TapHelper.cookiesRemove("passcode_passcode");
        TapHelper.cookiesRemove("passcode_mobile");
        TapHelper.cookiesRemove("passcode_mobile_display");
        clearOTP();
        setStep(1);
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }
    const goBackToLogin = () => {
        TapHelper.cookiesRemove("passcode_passcode");
        TapHelper.cookiesRemove("passcode_mobile");
        TapHelper.cookiesRemove("passcode_mobile_display");
        clearOTP();
        setFormData({
            passcode: "",
            mobile: "",
            otp: "",
        });
        setStep(1);
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }
    const formatMobileDisplay = (mobile) => {
        if (!mobile) return '';
        return `+91 ${mobile}`;
    };

    const loginStepjsx = () => {
        return (
            <form onSubmit={(e) => {
                e.preventDefault();
                handleSendOTP();
            }}>
                <div className="text-center mb-3 mb-md-4">
                    <h3 className="content_heading" style={{
                        color: "#1B2559",
                        fontSize: "clamp(18px, 3vw, 24px)",
                    }}>
                        Passcode Access
                    </h3>
                    <p style={{
                        color: "#6c757d",
                        fontSize: "clamp(12px, 1.5vw, 14px)",
                        marginBottom: "5px",
                    }}>
                        Enter your details to receive OTP
                    </p>
                </div>
                <div className="mb-3">
                    <label className="form-label">Passcode</label>
                    <div className="input-group">
                        <span className="input-group-text"><TapIcon.FontAwesomeIcon icon={TapIcon.faLock} /></span>
                        <input
                            name="passcode"
                            type="passcode"
                            value={formData.passcode}
                            onChange={(e) => handleChange("passcode", e.target.value)}
                            className="form-control"
                            required={true}
                            autoComplete="off"
                            placeholder="Enter New Passcode"
                        />
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Mobile Number</label>
                    <div className="input-group">
                        <span className="input-group-text"><TapIcon.FontAwesomeIcon icon={TapIcon.faPhone} /></span>
                        <input
                            name="mobile"
                            type="tel"
                            value={formData.mobile}
                            maxLength={10}
                            onChange={(e) =>
                                handleChange(
                                    "mobile",
                                    e.target.value.replace(/\D/g, "").slice(0, 10)
                                )
                            }
                            className="form-control"
                            required
                            autoComplete="off"
                            placeholder="Enter Mobile Number"
                        />
                    </div>
                </div>
                <div className="d-grid gap-2 mt-4 mb-2">
                    <button
                        type="submit"
                        className="btn btn-primary btn-lg mt-2"
                        disabled={!isLoginValid || loading}
                    >
                        Submit
                    </button>
                </div>
                <div
                    className="text-center"
                    style={{
                        marginTop: "clamp(15px, 2vw, 20px)",
                        color: "#6c757d",
                        fontSize: "clamp(11px, 1.2vw, 13px)",
                    }}
                >
                    <TapIcon.FontAwesomeIcon
                        icon={TapIcon.faShieldAlt}
                        style={{ color: "#3cb5a0", marginRight: "6px" }}
                    />
                    Secure • Encrypted • Trusted
                </div>
            </form>
        );
    };
    const OTPStep = () => {
        return (
            <form onSubmit={(e) => { e.preventDefault(); handleVerifyOTP(); }}>
                <div className="text-center mb-2 mb-md-3">
                    <h3 className="content_heading" style={{
                        color: "#1B2559",
                        fontSize: "clamp(18px, 2.5vw, 20px)",
                    }}>
                        Verify OTP
                    </h3>
                    <p className="mb-0" style={{
                        color: "#6c757d",
                        fontSize: "clamp(12px, 1.3vw, 14px)",
                    }}>
                        We've sent a 6-digit OTP to your mobile number
                    </p>
                </div>

                <div
                    className="d-flex justify-content-between align-items-center p-2 p-md-3 mb-2 mb-md-3 gap-2"
                    style={{ background: "#F8F9FA" }}>
                    <div className="d-flex flex-column gap-1 gap-sm-2 gap-md-3" style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ minWidth: 0, flex: "1 1 auto" }}>
                            <div className="fw500" style={{ fontSize: "clamp(11px, 1vw, 12px)", color: "#999"}}>
                                Passcode
                            </div>
                            <div className="fw600" style={{
                                color: "#1B2559",
                                fontSize: "clamp(12px, 1.3vw, 14px)",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "clamp(70px, 10vw, 120px)",
                            }}>
                                {formData.passcode || "-"}
                            </div>
                        </div>
                        <div style={{ minWidth: 0, flex: "1 1 auto" }}>
                            <div className="fw500" style={{ fontSize: "clamp(11px, 1vw, 12px)", color: "#999" }}>
                                Mobile Number
                            </div>
                            <div style={{
                                fontWeight: "600",
                                color: "#1B2559",
                                fontSize: "clamp(12px, 1.3vw, 14px)",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "clamp(80px, 12vw, 140px)",
                            }}>
                                {formatMobileDisplay(mobileDisplay || formData.mobile)}
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="cursor_pointer fw600"
                        onClick={editData}
                        style={{
                            background: "none",
                            border: "none",
                            color: "#3cb5a0",
                            fontSize: "clamp(12px, 1.2vw, 13px)",
                            padding: "4px 6px",
                            flexShrink: 0,
                        }}
                    >
                        Edit
                    </button>
                </div>

                <div className="mb-2 mb-md-3">
                    <label className="form-label fw500" style={{
                        fontSize: "clamp(12px, 1.2vw, 14px)",
                        color: "#333",
                    }}>
                        Enter OTP
                    </label>
                    <div
                        className="display-flex justify-content-center"
                        style={{
                            gap: "clamp(4px, 1vw, 8px)",
                            padding: "5px 0",
                            flexWrap: "wrap",
                            display: "flex",
                            justifyContent: "center",
                        }}
                        onPaste={handleOtpPaste}
                    >
                        {[0, 1, 2, 3, 4, 5].map((index) => (
                            <input
                                className="content_heading bg-white"
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                type="text"
                                maxLength={1}
                                autoFocus={index === 0}
                                value={otpInputs[index]}
                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                style={{
                                    width: "clamp(36px, 4.5vw, 48px)",
                                    height: "clamp(36px, 5.5vw, 48px)",
                                    fontSize: "clamp(14px, 2vw, 20px)",
                                    border: otpInputs[index] ? "2px solid #3cb5a0" : "2px solid #E5E7EB",
                                    outline: "none",
                                    color: "#1B2559",
                                    transition: "all 0.2s ease",
                                    flex: "0 0 auto",
                                    textAlign: "center",
                                }}
                                autoFocus={index === 0}
                            />
                        ))}
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2 mb-md-3">
                    <span style={{
                        fontSize: "clamp(10px, 1vw, 12px)",
                        color: "#6c757d",
                    }}>
                        Didn't receive OTP?
                    </span>
                    <button
                        type="button"
                        onClick={handleResendOTP}
                        disabled={isResendDisabled}
                        style={{
                            background: "none",
                            border: "none",
                            color: isResendDisabled ? "#999" : "#3cb5a0",
                            fontWeight: isResendDisabled ? "400" : "600",
                            fontSize: "clamp(10px, 1vw, 12px)",
                            cursor: isResendDisabled ? "not-allowed" : "pointer",
                            padding: 0,
                            textDecoration: isResendDisabled ? "none" : "underline",
                        }}
                    >
                        {isResendDisabled
                            ? `Resend OTP in ${String(Math.floor(countdown / 60)).padStart(2, '0')}:${String(countdown % 60).padStart(2, '0')}`
                            : "Resend OTP"
                        }
                    </button>
                </div>
                <div className="d-grid mt-2 mb-2">
                    <button
                        type="submit"
                        className="btn btn-primary btn-lg  mb-2"
                        disabled={!isOtpValid || loading}
                    >
                        {loading ? "Verifying..." : "Verify & Continue"}
                    </button>
                </div>

                <button
                    type="button"
                    className="text-start cursor_pointer "
                    onClick={goBackToLogin}
                    style={{
                        background: "none",
                        border: "none",
                        color: "#6c757d",
                        fontSize: "clamp(11px, 1.2vw, 13px)",
                        cursor: "pointer",
                        padding: 0,
                    }}
                >
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faArrowLeft} style={{ marginRight: "6px" }} />
                    Back to Login
                </button>
            </form>
        );
    };
    const SuccessStep = () => {
        return (
            <div className="text-center">
                <div className="d-flex justify-content-center align-items-center"
                    style={{
                        width: 95,
                        height: 95,
                        margin: "0 auto",
                        background: "#E9FBF6",
                        boxShadow: "0 10px 30px rgba(60,181,160,.25)",
                    }}
                >
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faCheck} style={{ fontSize: 42, color: "#3CB5A0" }} />
                </div>

                <h3 className="content_heading mt2"
                    style={{ color: "#1B2559" }}>
                    Verification Successful!
                </h3>

                <p
                    style={{
                        color: "#6B7280",
                        marginBottom: 25,
                    }}
                >
                    Your compliance access has been verified successfully.
                </p>

                <div
                    className="fs14 mt-3"
                    style={{
                        color: "#6B7280",
                    }}
                >
                    Redirecting to Dashboard...
                </div>
            </div>
        );
    };
    return (
        <Ax>
            <Helmet>
                <title>TappetBox - Compliance Access</title>
            </Helmet>
            {step !== 4 &&
                <div className="d-flex flex-column" style={{ minHeight: "100vh", overflow: "hidden" }}>
                    <TopHeader phone="9650-222-555" showData={false} />
                    <div className="container py-2 py-md-4 flex-grow-1" style={{ overflow: "auto" }}>
                        <div className="row justify-content-center align-items-start align-items-md-center">
                            <div className="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                                <div
                                    className="card border-0 bg-white"
                                    style={{
                                        boxShadow: "0 20px 60px rgba(0,0,0,.08)",
                                        overflow: "hidden",
                                        padding: "clamp(15px, 2.5vw, 25px) clamp(15px, 2.5vw, 30px) clamp(18px, 2.5vw, 25px)",
                                    }}
                                >
                                    {step === 1 && (
                                        loginStepjsx()
                                    )}

                                    {step === 2 && (
                                        OTPStep()
                                    )}

                                    {step === 3 && SuccessStep()}

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>}
            {step === 4 && (
                <Asset
                    assetId={assetId}
                    passcode={formData.passcode}
                    mobile={formData.mobile}
                    onSessionExpired={handleSessionExpired}
                    mobileDisplay={mobileDisplay || formData.mobile}
                />
            )}
        </Ax>
    );
};

export default Auth;